<template>
  <div>
    <div v-if="loading" class="ctx-layout-spinner" style="display: block;top: 50%;transform: translateY(-50%);"><i class="ctx-spinner"><i></i><i class="ico-ctx-loading-full"><i class="ico-ctx-loading-1"></i></i></i></div>
    <div v-if="!isMobile()" id="resource_library_app" :class="{ rl__loading: loading }">     
      <div :style="cssProps" class="rl__menu">
        <Search :reset="reset" :onSearch="onChange"  :resetView="resetValue" />
        <Filters :selectedValues="selectedValues" @updateData="onFilterChange"> 
          <div @click="toggleChecked()" v-if="showIncludeCheckbox" :class="[ isChecked ? 'isCheckActive filterCheck' : 'filterCheck' ]">{{$t('includeEnglishRes')}}</div>
        </Filters>
        <div v-if="isFiltered" class="rl__clear_filters">
          <div>
            <div v-if="isMenuFiltered" class="ctx-text"><a><span class="rl__clear-all" @click="clearMenuFilters">{{$t('clearAllFilters')}}</span></a></div>
            <div  class="rl__filter_items" v-for="(key, index) in Object.keys(selectedValues)" v-bind:key="index">
              <strong v-if="selectedValues[key].length > 0">{{ translateKey(key) }}</strong>
              <ul>
                <li class="rl__filter_item" v-for="item in selectedValues[key]" v-bind:key="item.id">
                  <span @click="removeFilterItem(key, item)" class="ico-ctx-decline"></span>
                  <span>{{ item.name }}</span>
                </li>
              </ul>
            </div>
          </div>

          <div class="rl__reset">
            <div v-if="searchQuery !== ''">{{$t('searchResults')}} "{{ searchQuery }}"</div>
            <div v-if="searchQuery !== ''" @click="resetValue" class="ctx-button primary ctx-blue ctx-medium-btn rl__search-reset">
              {{$t('resetView')}}
            </div>
          </div>

          <div class="rl__no-results" v-if="isFiltered && filteredData.length === 0">{{$t('noResultsFound')}}</div>

        </div>
      </div>
    
      <CardTemplate v-if="isFiltered" :items="filteredData" rowCount="8"/>
      <CardTemplate v-if="!isFiltered && !apiError" :items="toggleData" :title="$t('titles.label2')"/>
    </div>
    <div :style="cssProps" :class="[loading ? 'rl__mobile_view loading' : 'rl__mobile_view']" v-else>
      <Search :clearSearch="resetValue" :resetView="resetValue" :reset="reset" :onSearch="onChange" /> 
     <Filters class="rl__mobile_filter" :showClearAll="isFilterApplied" :isChecked ="isChecked" :toggleEnglish="toggleChecked" :showCheckbox="showIncludeCheckbox" :selectedValues="selectedValues" @updateData="onFilterChange" :isFilterApplied="isMenuFiltered">
       <div class="rl__mobile_view-info" v-if="searchQuery !== ''">{{$t('searchResults')}} "{{ searchQuery }}"</div>
      </Filters>
     <div class="rl__no-results" v-if="isFiltered && filteredData.length === 0">{{$t('noResultsFound')}}</div>
       <div class="rl__mobile_view-body">
          <CardTemplate v-if="isFiltered && !isChecked" :items="filteredData"/>
          <CardTemplate v-if="!isFiltered && !isChecked" :items="toggleData" :title="$t('titles.label2')" />
          <CardTemplate v-if="isChecked && !isFiltered" :items="toggleData" :title="$t('titles.label2')" /> 
          <CardTemplate v-if="isChecked && isFiltered" :items="filteredData" :title="$t('titles.label2')" /> 
       </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CardTemplate from "./components/CardTemplate.vue";
import Search from "./components/Search.vue";
import Filters from "./components/Filters.vue";
import commonMixins from './mixins/common';
import { geoSites } from './utils/constants';
import translations from './translations';

export default {
  name: "App",
  mixins: [commonMixins],
  components: {
    CardTemplate,
    Search,
    Filters
  },
  data() {
    return {
      cardData: [],
      searchQuery: "",
      filteredData: [],
      reset: false,
      selectedValues: {},
      loading: false,
      isChecked: false,
      defaultData: [],
      apiError: false,
      isEngLocale: true,
      timeOut: null,
      showRecentlyViewed: true,
      showTredingNow: true,
      showRecommended: true,
      filterObj: window.CTX_RL.filter_data,
      themeColor: window.CTX_RL.theme_color || "#05758a",
      hoverColor: window.CTX_RL.hover_color || "#1c9cad",
      siteName: window.CTX_RL.siteName
      };
  },

  methods: {
    clearSearch() {
      this.resetValue();
    },

    toggleChecked() {
       this.isChecked = !this.isChecked;
       this.filterData();
    },

    getTranslations() {
      return translations[this.$i18n.locale] || translations["en-us"];
    }, 

     translateKey(key) {
      var data = Object.keys(this.filterObj).length > 0 ? this.filterObj: this.getTranslations();
      return  data.filterData[key].label.toUpperCase();
    },

    resetValue() {
      this.reset = true;
      this.searchQuery = "";
      this.onFilterChange({});
    },

    removeFilterItem(key, item) {
      const existingItems = this.selectedValues[key];
      const index = existingItems.findIndex((ele) => {
        return ele.id === item.id;
      });
      existingItems.splice(index, 1);
      this.selectedValues[key] = existingItems;
      this.filterData();
    },

    filterData() {
      const searchValue = this.searchQuery.toLowerCase();
      const isFilterApplied = Object.keys(this.selectedValues).some(key => this.selectedValues[key].length > 0);
      if (this.searchQuery && isFilterApplied) {
        this.filteredData = this.toggleData.filter(({ headline, description, categories, type }) => {
            const hline = headline.toLowerCase();
            const desc = description.toLowerCase();
            const isSelected = Object.keys(this.selectedValues).every(selectedItem => {
               const values = this.selectedValues[selectedItem];
               if(values.length > 0) { 
                if(selectedItem !== 'Type') 
                return ((hline.indexOf(searchValue) > -1 ||desc.indexOf(searchValue) > -1) &&
                  values.some(item =>categories[selectedItem.toLowerCase()].indexOf(item.id) > -1
                  )
                );
                else
                return ((hline.indexOf(searchValue) > -1 ||desc.indexOf(searchValue) > -1) &&
                  values.some(item => type === item.id
                  )
                )}
                else return true
              }
            );
            return isSelected;
          }
        );
      } else if (isFilterApplied) {
        this.filteredData = this.toggleData.filter((card) => {
          const isSelected = Object.keys(this.selectedValues).every(selectedItem => {
            const values = this.selectedValues[selectedItem];
            if(values.length > 0) {
              if(selectedItem !== 'Type')
                return values.some(item =>card.categories[selectedItem.toLowerCase()].indexOf(item.id) > -1);
              else
                return values.some(item => card.type === item.id);
              } else
                return true;
            });
          return isSelected;
        });
      } else {
        this.filteredData = this.toggleData.filter(({ headline, description }) =>
            headline.toLowerCase().indexOf(searchValue) > -1 ||
            description.toLowerCase().indexOf(searchValue) > -1
        );
      }
    },

    onFilterChange(args) {
      this.selectedValues = { ...args };
      this.filterData();
    },

    sortData(array) {
      // Convert 'date' strings to Date objects or use null for objects without 'date'
      const data = (array || []).map((item) => ({...item, date: item.date ? new Date(item.date) : null}));
      const sortedArr =   data.sort((a, b) => {
        const dateComparison = (a.date !== null && b.date !== null) ? b.date - a.date : a.date === null ? 1 : -1;
        return dateComparison;
      });
      return sortedArr;
    },

    filterApplied() {
      return Object.keys(this.selectedValues).some(key => this.selectedValues[key].length > 0);
    },

  getCardData() {
      this.cardData = [];
      this.loading = true;
      const site = this.siteName ? this.siteName: this.extractSiteName(window.location.host);
      const apiUrl =  `/bin/${site}/resources.json`;
      setTimeout(() => {
     axios
       .get(apiUrl)
       .then((response) => {
          this.apiError = false;
          this.sorted = this.sortData(response.data.data);
          this.cardData = this.formatAEMData(this.sorted);
          this.defaultData = this.formatAEMData(this.sorted.filter(item => item.translated === true))
          this.loading = false;  
          if(this.filterApplied())
            this.filterData();
       })  
       .catch(error => {
         this.apiError = true
          this.loading = false
          if(error.response) console.log(` ${error.response.config.url} failed with status ${error.response.status}`)
        });
   }, 500)
    },

  formatTags(items) {
      return items.map(tag => tag[0].toUpperCase() + tag.substring(1))
      
    },

 formatAEMData(cards) {
    return cards.map(({headline, description, types, topics, date, link, products, solutions, industries,
    cardLink_da_dk, cardLink_de_de, cardLink_es_es, cardLink_fi_fi, cardLink_fr_fr, cardLink_it_it, cardLink_ja_jp,
    cardLink_ko_kr, cardLink_nl_nl, cardLink_no_no, cardLink_pl_pl, cardLink_pt_br, cardLink_ru_ru, cardLink_sv_se, 
    cardLink_tr_tr, cardLink_zh_cn
    }) => {
      return {
        headline: headline || '',
        description: description || '',
        type: types || '',
        tags: typeof topics === 'string' ? topics.split(',') : topics || [],
        products: typeof products === 'string' ? products.split(',') : products || [],
        industries: typeof industries === 'string' ? industries.split(',') : industries || [],
        solutions: typeof solutions === 'string' ? solutions.split(',') : solutions || [],
        date: date || '',
        categories: {
          products: typeof products === 'string' ?  products.split(',') : products || "",
          topics: typeof topics === 'string' ? topics.split(',') : topics || "",
          industry: typeof industries === 'string' ? industries.split(',') : industries || "",
          solutions: typeof solutions === 'string' ? solutions.split(',') : solutions || ""
        },
        link : {
          "da" : cardLink_da_dk || link,
          "de": cardLink_de_de || link,
          "en-us" : link || "",
          "es": cardLink_es_es || link,
          "fi": cardLink_fi_fi || link,
          "fr": cardLink_fr_fr || link,
          "it":cardLink_it_it || link,
          "ja":cardLink_ja_jp || link,
          "ko":cardLink_ko_kr || link,
          "nl": cardLink_nl_nl || link,
          "no": cardLink_no_no || link,
          "pl": cardLink_pl_pl || link,
          "pt": cardLink_pt_br || link,
          "ru":cardLink_ru_ru || link,
          "sv": cardLink_sv_se || link,
          "tr":cardLink_tr_tr || link,
          "zh": cardLink_zh_cn || link
        }
      } 
    })
},

    onChange(value) {
      this.reset = false;
      this.searchQuery = value;
      this.filterData();
    },
    clearMenuFilters() {
      this.onFilterChange({});
    },
    fetchData() {
      this.getCardData(); 
    },
    resizeHandler() {
      clearTimeout(this.timeOut)
      this.timeOut = setTimeout(() => {
        this.$forceUpdate(); 
      },50)
    }
  },

  created() {
    this.showRecentlyViewed = !window.CTX_RL.hide_recentlyViewed;
    this.showTredingNow = !window.CTX_RL.hide_trending;
    this.showRecommended = !window.CTX_RL.hide_recommended;
    this.languageCheck();
    this.fetchData(); 
    this.isMobile();
    window.addEventListener("resize", this.isMobile);
    window.addEventListener("resize", this.resizeHandler);
    const lang = document.getElementsByTagName("html")[0].getAttribute("lang");
    this.isEngLocale =  lang === 'en';
  },

  destroyed() {
  window.removeEventListener("resize", this.isMobile);
  window.removeEventListener("resize", this.resizeHandler);
},
  computed:  {
    cssProps() {
      return {
        '--theme-color' : this.themeColor,
        '--hover-color' : this.hoverColor
      }
    },
    
    isFilterApplied() {
      return Object.keys(this.selectedValues).some(key => this.selectedValues[key].length > 0)
    },
  toggleData() {
    if(!geoSites.includes(this.windowLocale()) || this.isChecked ) return this.cardData;
    return this.defaultData;
  },
  showIncludeCheckbox() {
    return geoSites.includes(this.windowLocale())
  },
  isMenuFiltered() {
    return Object.keys(this.selectedValues).some(key => this.selectedValues[key].length > 0);
  },
  isFiltered() {
    return this.searchQuery !== "" || this.isMenuFiltered;
    },
}
};
</script>

<style lang="scss">
@import "css/_global.scss";
@import "css/components/mobile.scss";

body {
  @include font-PublicSans-Regular;
}

.rl__mobile_view.loading {
  opacity: 0.1;
}
#resource_library_app.rl__loading {
  opacity: 0;
}
.ctx-layout-spinner  {
    .ctx-spinner {
      top: 35%;
    }
    .ico-ctx-loading-full {
      color: #ccc;
      position:relative;
      font-size: 5rem;

      .ico-ctx-loading-1 {
        transform-origin:52% 50% 0;
      }
    }
  }
.rl__clear_filters {
  cursor: pointer;
  width: 60%;
  margin: 0 auto;

  .ctx-text {
    padding-top: 5px;
  }
}
.rl__search-reset {
  cursor: pointer;
}
.rl__filter_item {
  padding-right: 20px;
  display: inline-block;
  border: 0;
  cursor: pointer;
}
.rl__filter_item .ico-ctx-decline {
  font-weight: bold;
  padding-right: 5px;
  color: var(--theme-color);
}
.rl__filter_items {
    padding: 10px 0;
    font-size: 15px;
    ul {
      padding: 0;
    }
}
.rl__card_template-title {
  display: flex;
  justify-content: space-between;
}
.rl__reset {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;

  div:first-child {
    font-size: 20px;
    font-weight: 500;
  }
}
.rl__no-results {
  @include font-PublicSans-RegularItalic();
  font-size: em(20);
  padding: 20px 0;
}
</style>
